export const DELETE = 'DELETE';

export const NON_WORKING = 'NON_WORKING';

export const CALENDAR_LOWER = 'calendar';

export const CLIENT = 'CLIENT';
export const SCS = 'SCS';
export const LUNCH = 'LUNCH';
export const EMPTY = 'EMPTY';
export const OVP = 'OVP';

export const PUBLIC_PLACE = 'PUBLIC_PLACE';
export const RESIDENTIAL = 'RESIDENTIAL';
export const NON_RESIDENTIAL = 'NON_RESIDENTIAL';
export const APP_FORECAST = 'APP_FORECAST';
export const ENGINEERING_NETWORK = 'ENGINEERING_NETWORK';

export const ANALYTICS = 'analytics';

export const CONTRACTOR = 'CONTRACTOR';
export const SETTLEMENT = 'SETTLEMENT';

export const DEFECTS = 'defects';

export const UNDISTRIBUTES_TIME = 'UNDISTRIBUTES_TIME';

export const SELECTED_KEY = 'SELECTED_KEY';

export const SEARCH = 'SEARCH';
